<div class="row pt-1" *ngIf="tooManyIdeas">
  <div class="col-md-12">
    <div class="alert alert-warning">
      <strong>Warning!</strong>
      The maximum number of ideas ({{ appConfig.MAX_IDEAS }}) drawn in the
      matrix below is reached. The ideas that have gone without interaction the
      longest will not be shown. Apply a filter to show more ideas.
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="idea-filter-group btn-group top-buffer">
      <button
        class="btn btn-primary"
        [ngClass]="{ active: isFilterSelected({ by: 'all' }) }"
        (click)="selectFilter({ by: 'all' })">
        All
      </button>
      <button
        class="btn btn-primary"
        [ngClass]="{
          active: isFilterSelected({
            by: 'participant_id',
            value: session.me._id,
          }),
        }"
        (click)="selectFilter({ by: 'participant_id', value: session.me._id })">
        Mine
      </button>
      <button
        class="btn btn-primary"
        [ngClass]="{
          active: isFilterSelected({ by: 'team', value: session.me.team }),
        }"
        (click)="selectFilter({ by: 'team', value: session.me.team })">
        My Team ({{ myTeam.name }})
      </button>
      <ng-container *ngFor="let team of session.config.teams">
        <button
          class="btn btn-primary"
          [ngClass]="{
            active: isFilterSelected({ by: 'team', value: team._id }),
          }"
          (click)="selectFilter({ by: 'team', value: team._id })"
          *ngIf="team._id !== session.me.team">
          {{ team.name }}
        </button>
      </ng-container>
    </div>
  </div>
  <div class="col-12 vote-filters">
    <span>Consider votes of</span>
    <div class="btn-group filter-dropdown">
      <div
        id="btn-append-to-single-button"
        class="filter-button"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {{ selectedGroup }}
        <span class="caret"></span>
      </div>
      <ul
        class="dropdown-menu filter-list"
        aria-labelledby="btn-append-to-single-button">
        <li role="menuitem">
          <a (click)="(selectedGroup = 'everyone') && redraw()">everyone</a>
        </li>
        <li
          role="menuitem"
          *ngIf="
            !session.config.matrix.role_view ||
            session.config.matrix.role_view.moderators
          ">
          <a (click)="(selectedGroup = 'moderators') && redraw()">moderators</a>
        </li>
        <li
          role="menuitem"
          *ngIf="
            !session.config.matrix.role_view ||
            session.config.matrix.role_view.participants
          ">
          <a (click)="(selectedGroup = 'participants') && redraw()">
            participants
          </a>
        </li>
        <li
          role="menuitem"
          *ngIf="
            !session.config.matrix.role_view ||
            session.config.matrix.role_view.externals
          ">
          <a (click)="(selectedGroup = 'external evaluators') && redraw()">
            external evaluators
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="col-12 pt-4">
    <div
      class="ratings-chart"
      echarts
      [options]="chartOptions"
      [merge]="chartMerge"
      (chartInit)="echart = $event"
      (chartClick)="onChartClick($event)"></div>
  </div>
</div>
